import { getRunText, isNumberBullet, hasBullet, propsToStyle } from '../../lib/ParserUtils';
import type { ISdkModel } from '../../store-manager';
import type { ImageBlobAndString } from '../image-prepare-plugin';
import BasePrepareModel from './base-prepare-model';
import { ICTTextParagraph } from '@tencent/slide-sdk-model';

class CustomElementPrepareModel extends BasePrepareModel {
    /**
     * 将需要复制的内存数据转化为html
     * @param htmlData
     * @return {string}
     */
    public getHtml(htmlData: ISdkModel, imageBlobAndString?: ImageBlobAndString): string {
        const sdkData = this.getFirstSelectedElement(htmlData);
        const needUseImageReplaceRichText = sdkData?.props?.txBox !== 1 && imageBlobAndString?.imgStr;
        if (needUseImageReplaceRichText) {
            return this.containerTagIsImage(htmlData, imageBlobAndString?.imgStr);
        }
        const containerTag = document.createElement('div');
        this.insertPrivateData(containerTag, htmlData);
        const paragraphList = sdkData.txBody?.p;
        paragraphList?.length && this.handlerParagraphList(paragraphList, containerTag);
        sdkData?.props?.addon?.displayMode === 'iframe' && containerTag.appendChild(this.handlerAddon(sdkData));
        return containerTag.outerHTML;
    }

    protected getFirstSelectedElement(selectedSdkDataArray: { data: any[]; }): any {
        const elementData = selectedSdkDataArray?.data?.[0];
        return elementData.inheritedSdkData || elementData;
    }

    /**
     * 处理插件逻辑
     * @param sdkData
     * @returns {HTMLElement}
     */
    private handlerAddon(sdkData) {
        const { originUrl, embedUrl, extraData, iframeId } = sdkData.props.addon;
        const addonDom = document.createElement('slide-data');
        addonDom.setAttribute('data-src', JSON.stringify({
            originUrl,
            embedUrl,
            extraData,
            iframeId,
        }));
        return addonDom;
    }

    /**
     * 根据项目符号创建对应的标签
     * @param {IParagraph} paragraph
     * @returns {HTMLUListElement}
     */
    private createNewListTag(paragraph) {
        let tag = document.createElement('ul');
        if (isNumberBullet(paragraph)) {
            tag = document.createElement('ol');
        }
        return tag;
    }

    /**
     * 处理文本段落相关数据
     * @param {IParagraph[]} paragraphList 段落数据
     * @param {HTMLDivElement} containerTag 根dom元素
     */
    private handlerParagraphList(paragraphList: ICTTextParagraph[], containerTag: HTMLDivElement) {
        let listTag: HTMLUListElement | null;
        paragraphList.forEach((paragraph) => {
            let paragraphTag: HTMLParagraphElement | HTMLLIElement;
            if (hasBullet(paragraph)) {
                if (!listTag) {
                    listTag = this.createNewListTag(paragraph);
                    containerTag.appendChild(listTag);
                }
                paragraphTag = document.createElement('li');
                listTag.appendChild(paragraphTag);
            } else {
                paragraphTag = document.createElement('p');
                containerTag.appendChild(paragraphTag);
                listTag = null;
            }
            propsToStyle({ ...paragraph.pPr }, paragraphTag.style);
            paragraph.egTextRun?.forEach((textRun) => {
                let tag;
                const { rPr } = textRun.r || {};
                if (rPr?.hlinkClick) {
                    tag = document.createElement('a');
                    tag.href = rPr.hlinkClick.id;
                } else {
                    tag = document.createElement('span');
                }
                const textNode = document.createTextNode(getRunText(textRun));
                tag.appendChild(textNode);
                propsToStyle(rPr, tag.style);
                paragraphTag.appendChild(tag);
            });
        });
    }
}

export default CustomElementPrepareModel;
